import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Col, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { formatters } from '@utils/intl/dateTimeFormatters'
import api from '../../../utils/api'
import dayjs from 'dayjs'

export function DirectiveGrouping({ row, as_of = null }) {
  const [directiveData, setDirectiveData] = useState()
  const location = useLocation()

  useEffect(() => {
    as_of = as_of || dayjs().local().toISOString()
    api
      .getDailyDirectivePrices({}, as_of, row.group_id)
      .then((resp) => resp && setDirectiveData(resp.data))
      .catch((err) => {
        console.log('Error-group_by_id:', err)
      })
  }, [as_of])
  if (!directiveData)
    return (
      <Horizontal verticalCenter horizontalCenter style={{ height: 48, minWidth: 100 }}>
        <Spin size='medium' />
      </Horizontal>
    )

  const getEffectiveDate = () => {
    if (location.pathname === '/reports') return null
    return `${formatters.DATE_TIME(dayjs(directiveData.directive_effective_from))} - 
    ${formatters.DATE_TIME(dayjs(directiveData.directive_effective_to))}`
  }

  return (
    <Vertical borderRadius='6px' style={{ minWidth: 700, margin: -12 }} bg='default'>
      {/* <Horizontal
        verticalCenter
        style={{ overflow: 'visible' }}
        gap={16}
        borderRadius='6px 6px 0 0'
        bg='default'
        border='all'
        className='px-2 py-3'
      >
        <Horizontal flex={2}>
          <Texto weight='bold' textTransform='uppercase' category='p2'>
            Group: {directiveData.name || 'N/A'}
          </Texto>
        </Horizontal>
        <Horizontal verticalCenter gap={4} flex='0' style={{ overflow: 'visible' }}>
          <Texto style={{ whiteSpace: 'nowrap' }}>Min:</Texto>
          <Texto weight='bold' style={{ whiteSpace: 'nowrap' }} category='p2'>
            {directiveData?.min || directiveData?.min === 0 ? addCommasToNumber(directiveData.min) : 'N/A'}
          </Texto>
        </Horizontal>
        <Horizontal verticalCenter gap={4} flex='0' style={{ overflow: 'visible' }}>
          <Texto style={{ whiteSpace: 'nowrap' }}>Max:</Texto>
          <Texto weight='bold' style={{ whiteSpace: 'nowrap' }} category='p2'>
            {directiveData?.max || directiveData?.max === 0 ? addCommasToNumber(directiveData.max) : 'N/A'}
          </Texto>
        </Horizontal>
      </Horizontal> */}
      {/* {location.pathname !== '/reports' && (
        <Horizontal verticalCenter gap={16} bg='elevated' border='all' className='px-2 py-3'>
          <Texto style={{ flex: 1 }} weight='bold' appearance='hint'>
            Effective:
          </Texto>
          <Texto>{getEffectiveDate()}</Texto>
        </Horizontal>
      )} */}

      <Horizontal bg='elevated' border='all' gap={16} className=' px-2 py-1'>
        <Texto
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 2.5, textTransform: 'uppercase' }}
          category='label'
        >
          Terminal
        </Texto>

        <Texto
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 1.5, textTransform: 'uppercase' }}
          category='label'
        >
          Product
        </Texto>
        <Texto
          align='right'
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 1, textTransform: 'uppercase' }}
          category='label'
        >
          Planned
        </Texto>
        <Texto
          align='right'
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 1, textTransform: 'uppercase' }}
          category='label'
        >
          Sched.
        </Texto>
        <Texto
          align='right'
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 1, textTransform: 'uppercase' }}
          category='label'
        >
          Loaded
        </Texto>

        <Texto
          align='right'
          appearance='hint'
          style={{ whiteSpace: 'nowrap', flex: 2, textTransform: 'uppercase' }}
          category='label'
        >
          Price
        </Texto>
      </Horizontal>
      <Vertical border='all' style={{ display: 'flex', maxHeight: '25vh', overflowY: 'auto' }}>
        {directiveData.map((c, i) => (
          <Horizontal
            flex={1}
            verticalCenter
            border={c.product !== row.product && 'bottom'}
            key={i}
            gap={16}
            className='row px-2 py-1'
            bg={c.product === row.product && c.terminal === row.terminal && 'primary'}
            style={{
              minHeight: '20px', // Enforce minimum height for rows
              flexShrink: 0, // Prevent items from shrinking
            }}
          >
            <Texto style={{ flex: 2.5, lineHeight: '1em' }}>{c.terminal}</Texto>
            <Texto style={{ flex: 1.5, lineHeight: '1em' }}>{c.product}</Texto>
            <Texto align='right' style={{ flex: 1 }}>
              {addCommasToNumber(c.loaded)}
            </Texto>
            <Texto align='right' style={{ flex: 1 }}>
              {addCommasToNumber(c.scheduled)}
            </Texto>
            <Texto align='right' style={{ flex: 1 }}>
              {addCommasToNumber(c.planned)}
            </Texto>
            <Vertical style={{ flex: 2, textAlign: 'right', overflow: 'visible' }}>
              <SupplyPriceTag price={c.price} deltaToLow={c.delta_to_low ?? 0} className='mb-2 report-tag popover' />
            </Vertical>
          </Horizontal>
        ))}
      </Vertical>
      {/* <Horizontal borderRadius='0 0 6px 6px' bg='elevated' border='all' gap={16} className='px-2 py-1'>
        <Texto style={{ flex: 2.5 }} weight='bold'>
          Grand Totals
        </Texto>
        <Texto align='right' style={{ flex: 1.5 }} />

        <Texto align='right' style={{ flex: 1 }}>
          {addCommasToNumber(directiveData.loaded)}
        </Texto>
        <Texto align='right' style={{ flex: 1 }}>
          {addCommasToNumber(directiveData.scheduled)}
        </Texto>
        <Texto align='right' style={{ flex: 1 }}>
          {addCommasToNumber(directiveData.planned)}
        </Texto>
        <Texto weight='bold' category='p2' align='right' style={{ flex: 2 }}>
          {addCommasToNumber(directiveData.total)}
        </Texto>
      </Horizontal> */}
    </Vertical>
  )
}

function SupplyPriceTag({ price, deltaToLow, className }) {
  const { formatCurrency } = useFormatter()
  const formattedPrice = formatCurrency(parseFloat(price), true, 4)
  if (deltaToLow == null) return <BBDTag className='mr-0' warning>{`${formattedPrice} (Old)`}</BBDTag>
  if (deltaToLow > 0) return <BBDTag className='mr-0' error>{`${formattedPrice} (+${deltaToLow.toFixed(4)})`}</BBDTag>
  return <BBDTag className='mr-0' success>{`${formattedPrice} (Low)`}</BBDTag>
}
